module.exports = __webpack_public_path__ + "static/media/ad-post-banner-on-list-mockup-upper.0effa715.png";